var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0002 225 0.0002 225 37.4901 0 37.4901"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 -2.84217094e-14 36 -2.84217094e-14 36 36 0 36"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button-red-download-test-pdf-hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-background",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0358596,9.47368421e-05 L18.0009603,9.47368422e-05 C8.07575353,9.47368422e-05 7.10542736e-15,8.07488802 7.10542736e-15,18.0000947 L7.10542736e-15,36.0000947 L18.0358596,36.0000947 C27.9610663,36.0000947 36.0358596,27.9253015 36.0358596,18.0000947 C36.0358596,8.07488802 27.9610663,9.47368421e-05 18.0358596,9.47368421e-05 Z",
    id: "Fill-1",
    fill: "#B14E79",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7,23.1l5.1-5.2c0.8,0.3,1.4,1,1.6,1.7l-8,8l-8-8c0.2-0.7,0.9-1.4,1.6-1.7l5.1,5.2V10.7 c0.2-0.1,0.6-0.2,1.2-0.2c0.6,0,1,0.1,1.2,0.2V23.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconRed);
export default __webpack_public_path__ + "static/media/download-icon-red.5a5841832d0b095d9a82f0a47d1e4e3f.svg";
export { ForwardRef as ReactComponent };